import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { ConfigProvider, App as AntApp } from 'antd';
import jaJP from 'antd/locale/ja_JP';
import { router } from '@/routes';
import { antTheme } from '@/config';
import { initializeQuillConfig } from '@/config/quillSetup';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';

// Set dayjs locale
dayjs.locale('ja');

// Initialize Quill custom configurations (fonts and sizes)
initializeQuillConfig();
const App: React.FC = () => {
  return (
    <ConfigProvider theme={antTheme} locale={jaJP}>
      <AntApp>
        <RouterProvider router={router} />
      </AntApp>
    </ConfigProvider>
  );
};

export default App;
